<ng-container [formGroup]="form">

    <mat-checkbox class="example-margin w-full"   [ngClass]="class" [formControlName]="controlName" [labelPosition]="'after'" [disabled]="disabled">
        <mat-label class="font-bold font-md mx-3">{{label |transloco}}</mat-label>
    </mat-checkbox>
</ng-container>